module.exports = __webpack_public_path__ + "img/taiwanHighSpeedRail-family.df02f56d.jpg";